<template>
  <div />
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'JobsListProvision',
  created() {
    this.fetchJobData()
    this.initializeJobColumns()
  },
  methods: {
    ...mapActions({
      fetchJobData: 'fetchJobData',
      initializeJobColumns: 'jobsList/tryInitializeColumns',
    }),
  },
}
</script>
